module.exports = __webpack_public_path__ + "static/media/bonair3.45512113.JPG";